<template>
  <div :class="['main_head', showMax?'max-height':'']">
    <corporateEquity ref="corporateEquity"></corporateEquity>
    <!-- <h1>臻寻客智能获客云平台</h1> -->
    <div class="careful-search">
      <span v-for="(item,index) in carefulList" :key="index" :class="activeTab==index?'active-class':''" @click="clickTab(item,index)">{{item.searchValue}}</span>
    </div>
    <div class="search">
      <el-autocomplete popper-class="recommend-head-autocomplete" :maxlength="50" :placeholder="placeholder" @keyup.enter.native="submit" @select="submit1" size="small" v-model="word"
        :fetch-suggestions="querySearch">
        <a @click="submit" slot="suffix" class="searchBtn">
          <div class="icon"></div>
        </a>
        <template slot-scope="{ item }">
          <div class="name" v-html="item.name"></div>
        </template>
      </el-autocomplete>
    </div>
    <div class="hot-search" v-if="showMax">
      <a v-for="(item,i) in enterList" :key="i" @click="jumpUrl(item)">
        <p>
          <!-- <i class="iconfont" :class="item.icon"></i>  -->
          <img class="img no-img" :src="item.img">
          <img class="img img-active" :src="item.imgActive">
          {{item.name}}
        </p>
      </a>
    </div>
  </div>
</template>

<script>
import { newGetTotalTimes } from '@/api/totals.js'
import { cueQuotaStatistics } from '@/views/home/api'
import { getByName } from '../api/newClueApi'
import { searchByCondition } from '../api/index'
import corporateEquity from '@/components/corporateEquity'

import iu01 from '@/assets/newicons/iu01.png'
import iu02 from '@/assets/newicons/iu02.png'
import iu03 from '@/assets/newicons/iu03.png'
import iu04 from '@/assets/newicons/iu04.png'
import iu11 from '@/assets/newicons/iu11.png'
import iu12 from '@/assets/newicons/iu12.png'
import iu13 from '@/assets/newicons/iu13.png'
import iu14 from '@/assets/newicons/iu14.png'

export default {
  props: ['showMax'],
  components: {corporateEquity},
  data () {
    return {
      word: '',
      enterList: [
        { name: '高级搜索', type: '6', url: '/zxk/junbros/advancedSearch', icon: 'icon-sousuoleimufill', img:iu01, imgActive:iu11 },
        { name: '商机地图', type: '7', url: '/zxk/junbros/map', icon: 'icon-ditu1', img:iu02, imgActive:iu12 },
        { name: '智能推荐', type: '8', url: '/zxk/junbros/intelRecommend', icon: 'icon-tuijian', img:iu03, imgActive:iu13 },
        // { name: '智能人脉', url: '', icon: 'icon-renmai' },
        // { name: '商机订阅', url: '', icon: 'icon-shangji' },
        // { name: '产业链路', type: '10', url: '/zxk/junbros/industryChain', icon: 'icon-chanyelianICON', img:iu04, imgActive:iu14 }
        { name: '产业获客', type: '10', url: '/zxk/industryChain', icon: 'icon-chanyelianICON', img:iu04, imgActive:iu14 }  //产业链路隐藏

        // { name: '商机地图', url: '/zxk/junbros/map', img: require('@/assets/home/z-1.png') },
        // { name: '最新企业', url: '/clue/newlyCompany', img: require('@/assets/home/z-2.png') },
        // { name: '高级搜索', url: '/zxk/junbros/advancedSearch', img: require('@/assets/home/z-3.png') },
        // { name: '招标查询', url: '/clue/biddingInquiry', img: require('@/assets/home/z-4.png') },
        // { name: '产业链路', url: '/zxk/junbros/industryChain', img: require('@/assets/home/z-5.png') },
        // { name: '匿名获客', url: '/zxk/junbros/getCustomers', img: require('@/assets/home/z-6.png') }
      ],
      carefulList: [
        // { searchValue: '智能搜索', field: 'word' },
        // { searchValue: '按人员', field: 'executives' },
        // { searchValue: '按产品', field: 'productName' },
        // { searchValue: '按网站', field: '' },
        // { searchValue: '按商标', field: '' },
        // { searchValue: '按专利', field: 'patentName' },
        // { searchValue: '按投标', field: '' },
        // { searchValue: '按地址', field: 'address' },
        // { searchValue: '按业务', field: '' },
        // { searchValue: '按号码', field: '' },
        // { searchValue: '按广告', field: '' },
        // { searchValue: '按招聘', field: '' },
        // { searchValue: '按统一码', field: '' }
        { searchValue: '智能搜索', field: 'word' },
        { searchValue: '企业名称', field: 'companyName' },
        { searchValue: '经营范围', field: 'businessScope' },
        { searchValue: '产品', field: 'productName' },
        { searchValue: '法人/高管', field: 'executives' },
        { searchValue: '专利', field: 'patentName' },
        { searchValue: '地址', field: 'regAddress' },
        { searchValue: '网络推广', field: 'bidKeyWord' }
      ],
      activeTab: 0,
      placeholderList: ['请输入企业名称、手机号、产品名、经营范围、统一信用代码等，多关键词用空格隔开，如：“上海 珍岛”', '请输入企业名称', '请输入主营业务或经营范围关键词', '请输入产品', '请输入一个完整姓名（支持企业法人/高管等）', '请输入专利名称或说明', '请输入地址或地区，系统为您推荐附近企业','请输入关键词']
      // placeholderList: ['请输入企业名称、产品名、经营范围、统一信用代码等，多关键词用空格隔开，如：“上海 珍岛”', '输入法人、固定、高管姓名', '输入产品、APP名称', '输入网站名称', '输入商标名称', '输入专利名称或说明', '输入招标项目名称或公告名称', '输入地址或地区，系统为您推荐附近企业', '输入主营业务或经营范围的关键词', '输入联系方式，包括：手机号码、固话、邮箱', '输入网络推广关键词', '输入招聘名称', '输入统一信用代码']
    }
  },
  computed: {
    filterValue: {
      get() {
        return this.carefulList[this.activeTab].field
      },
      set(val) {},
    },
    placeholder () {
      return this.placeholderList[this.activeTab]
    }
  },
  watch: {
  },
  mounted () {
    if (this.$route.query.hide) {
      this.enterList = [
        { name: '高级搜索', type: '6', url: '/zxk/junbros/advancedSearch', icon: 'icon-sousuoleimufill', img:iu01, imgActive:iu11 },
        { name: '商机地图', type: '7', url: '/zxk/junbros/map', icon: 'icon-ditu1' , img:iu02, imgActive:iu12},
        { name: '智能推荐', type: '8', url: '/zxk/junbros/intelRecommend', icon: 'icon-tuijian', img:iu03, imgActive:iu13 }
      ]
    }
  },
  methods: {
    clickTab (item, index) {
      this.activeTab = index
      // this.getByName()
    },
    jumpUrl (item) {
      if (window.__sendIframeLinkMessage({ type: item.type })) return
      if (item.url) {
        this.$router.push(item.url)
      } else {
        // this.$message.warning('开发中...')
        this.$message.warning('功能升级中，暂未开放')
      }
    },

    submit ({ name }) {
      this.clickSearch(this.removeHtml(name))
    },
    // 由于后面有经营范围、产品、法人/高管、专利、地址
    submit1 ({ name }) {
      if (this.activeTab != 1) {
        this.activeTab = 0
        this.filterValue = 'word'
      }
      this.clickSearch(this.removeHtml(name))
    },
    removeHtml (str) {
      if (!str) return
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    clickSearch (val) {
      if (!val && !this.word) {
        this.$message.warning('请输入关键词！')
        return false
      }
      const query = { field: this.filterValue, word: val || this.word, activeTab: this.activeTab }
      if (window.__sendIframeLinkMessage({type: '2-1', query})) return
      this.$router.push({ path: '/zxk/search/clueList', query })
    },

    async getByName (name) {
      const params = {
        // name:name,
        pageSize: 5,
        [this.filterValue]: this.word.trim(),
        searchFlag: true
      }
      const res = await searchByCondition(params)
      // const res = await getByName({ name })
      return res.data.items.map(e => {
        return {
          name: e.name,
          value: e.unlabeledCompanyName
        }
      })
    },
    async querySearch (queryString = '', cb) {
      if (queryString.length > 1) {
        // if (this.lastSearch !== this.word) {
        this.lastSearch = this.word
        const res = await this.getByName()
        this.lastSearchArr = res
        console.log(111, this.lastSearchArr)
        // }
      } else {
        this.lastSearch = this.word
        this.lastSearchArr = []
      }
      cb(this.lastSearchArr)
    }
  }
}
</script>
<style lang="scss" scoped>
.main_head {
  height: 163px;
  background-image: url('~@/assets/industry/header-bg.jpg');
  background-size: 100% 100%;
  // border-radius: 7px;
  position: relative;
  padding-top: 32px;
  &.max-height{
    height: 208px;
  }
  h1 {
    font-size: 40px;
    color: #fff;
    font-weight: 400;
    text-align: center;
    line-height: 100px;
    height: 100px;
  }
  /deep/.el-autocomplete {
    width: 100%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .el-input__inner {
      height: 44px;
      // border-radius: 0;
      padding-right: 50px;
      border: unset;
      border: none;
    }
    .el-input__suffix {
      right: 0;
    }
    .el-input__suffix .searchBtn {
      display: inline-block;
      color: #fff;
      height: 44px;
      width: 50px;
      padding: 12px;
      text-align: center;
      border: 0;
      border-radius: 0;
      .icon {
        width: 20px;
        height: 20px;
        background-image: url('~@/assets/icon/search.svg');
      }
      &:hover {
        color: #aaa;
      }
      cursor: pointer;
      i {
        margin-right: 10px;
      }
      display: inline-block;
      line-height: 44px;
      height: 100%;
      font-size: 18px;
    }
  }
  .search {
    // width: 1000px;
    width: 66%;
    max-width: 910px;
    min-width: 910px;
    margin: 0 auto;
  }
  .hot-search {
    font-size: 13px;
    // margin-bottom: 25px;
    text-align: center;
    margin-top: 12px;
    display: flex;
    justify-content: center;
    img {
      width: 30px;
      margin-bottom: 5px;
    }
    span {
      width: 74px;
      height: 30px;
      border-radius: 4px;
      line-height: 31px;
      text-align: center;
      display: inline-block;
      color: #236CEF;
      background-color: #fff;
    }
    a {
      padding: 10px 20px;
      background: rgba(179,210,255, 0.2);
      border-radius: 4px;
      color: #fff;
      margin: 0 16px;
      width: 137px;
      i{
        margin-right: 5px;
      }
      &:hover{
        background: #fff;
        color: rgba(80, 136, 255, 1);
        .img-active{
          display: inline-block;
        }
        .no-img{
          display: none;
        }
      }
    }
    .img{
      width: 18px;
      height: 18px;
      margin: 0;
      margin-right: 6px;
    }
    .img-active{
      display: none;
    }
  }
  .careful-search {
    display: flex;
    justify-content: space-around;
    width: 60%;
    min-width: 800px;
    margin: auto;
    margin-bottom: 17px;
    .active-class {
      background: #fff;
      color: #236CEF;
      position: relative;
      border-radius: 4px;
      font-weight: bold;
    }
    .active-class::after {
      content: '';
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      bottom: -7px;
      border-top: solid 7px #fff;
      border-right: solid 7px transparent;
      border-left: solid 7px transparent;
    }
    span {
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      padding: 4px 12px;
    }
  }
}
</style>
